import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Logo from "../assets/logo.png";
import { useEffect, useState } from "react";
import { RUTA_IMG } from "../componentes/config";
import ReactPlayer from "react-player";
import { DocumentViewer } from "react-documents";

const VerAdjuntos = (props) => {
  const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;
  const [tipo, setTipo] = useState("");

  useEffect(() => {
    setTipo(props.tipoAnexo);
  }, [props.ruta, props.tipoAnexo]);

  const previsualizar = () => {
    if (tipo === 1) {
      //Video
      return (
        <div className="player-wrapper">
          <ReactPlayer
            className="react-player"
            url={RUTA_IMG + props.ruta + props.archivo}
            width="100%"
            height="100%"
            controls={true}
          />
        </div>
      );
    } else if (tipo === 2) {
      //Imagen
      return (
        <div className="d-flex justify-content-center">
          <img
            src={RUTA_IMG + props.ruta + props.archivo}
            className="img-fluid"
            alt="Imagen"
          />
        </div>
      );
    } else if (tipo === 3) {
      //Documentos
      return (
        <DocumentViewer
          url={RUTA_IMG + props.ruta + props.archivo}
          viewer={"google"} // 'google' o 'office'
          style={{ width: "100%", height: "500px" }}
        />
      );
    } else if (tipo === 4) {
      //Audios
      return (
        <div className="row">
          <audio controls>
            <source
              src={RUTA_IMG + props.ruta + props.archivo}
              type="audio/mpeg"
            />
            Tu navegador no soporta el elemento de audio.
          </audio>
        </div>
      );
    }
  };

  const salir = () => {
    props.setVerAnexos(false);
  };

  return (
    <Modal
      show={props.setVerAnexos}
      onHide={salir}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <img
          src={Logo}
          className="img-fluid"
          width="40px"
          height="120px"
          alt="logo"
        />
        <Modal.Title> {tab} VISUALIZADOR DE ANEXOS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {previsualizar()}
        <Modal.Footer>
          <Button variant="secondary" onClick={salir}>
            Salir
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default VerAdjuntos;
